import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useInvoice } from '../context/InvoiceContext';

const { FiChevronDown, FiPackage } = FiIcons;

const ProductSelector = ({ item, onChange }) => {
  const { savedProducts } = useInvoice();
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleProductSelect = (product) => {
    onChange('name', product.name);
    onChange('description', product.description);
    // Don't set the price automatically, but you can set the currency if needed
    if (product.currency) {
      // This would need to be handled at the invoice form level
      // to update the invoice currency based on the product
    }
    setShowSuggestions(false);
  };

  const filteredProducts = savedProducts.filter(product =>
    product.name.toLowerCase().includes(item.name.toLowerCase()) ||
    product.description.toLowerCase().includes(item.name.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Product/Service Name
        </label>
        <div className="relative">
          <input
            type="text"
            value={item.name}
            onChange={(e) => {
              onChange('name', e.target.value);
              setShowSuggestions(e.target.value.length > 0);
            }}
            onFocus={() => setShowSuggestions(item.name.length > 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-10"
            placeholder="Enter product or service name"
            required
          />
          {savedProducts.length > 0 && (
            <button
              type="button"
              onClick={() => setShowSuggestions(!showSuggestions)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <SafeIcon icon={FiChevronDown} className="w-4 h-4" />
            </button>
          )}
        </div>

        <AnimatePresence>
          {showSuggestions && filteredProducts.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-40 overflow-y-auto"
            >
              {filteredProducts.map((product, index) => (
                <motion.button
                  key={product.id}
                  type="button"
                  onClick={() => handleProductSelect(product)}
                  className="w-full text-left px-4 py-3 hover:bg-gray-50 border-b border-gray-100 last:border-b-0 flex items-start space-x-3"
                  whileHover={{ backgroundColor: '#f9fafb' }}
                >
                  <SafeIcon icon={FiPackage} className="w-4 h-4 text-gray-400 mt-1 flex-shrink-0" />
                  <div>
                    <div className="font-medium text-gray-900">{product.name}</div>
                    <div className="text-sm text-gray-500 truncate">{product.description}</div>
                    {product.currency && (
                      <div className="text-xs font-medium text-blue-600 mt-1">
                        Default currency: {product.currency}
                      </div>
                    )}
                  </div>
                </motion.button>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Description
        </label>
        <textarea
          value={item.description}
          onChange={(e) => onChange('description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Enter product or service description"
          required
        />
      </div>
    </div>
  );
};

export default ProductSelector;